import React from "react";
import Spinner from 'react-bootstrap/Spinner';

const PortalSpinner = ({
    label = 'Carregando...',
    description = '',
    block = false,
    compact = false
}) => (
    <div className={`portal-loading${block ? ' is-block' : ''}${compact ? ' is-compact' : ''}`}>
        <Spinner animation="border" role="status" size={compact ? 'sm' : undefined} />
        <div className="portal-loading-copy">
            <strong>{label}</strong>
            {description ? <span>{description}</span> : null}
        </div>
    </div>
);

export default PortalSpinner;
